export const INITIAL_FEED_STATE = {
    entities: {},
    feedCount: null,
    stream: [],
    feedIsLoading: false,
    feedBookmark: 0,
    filters: {}
};

export const FEED_BATCH_SIZE = 7;